// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__1-FlE"};